

import {Options, setup, Vue} from "vue-class-component";
import {reactive, toRefs, watch} from "vue";

@Options({
  name: 'sms-detail-modal',
  props: {
    value: {
      type: Boolean
    },
    recordData: {
      type: Object
    }

  },
  emits: ["update:value", "finish"]
})
export default class SmsDetailModal extends Vue {

  modalInfo = setup(() => {
    //modal
    const modalConfig: any = reactive({
      visible: false,
      modalTitle: "",
    })
    const {value} = toRefs<any>(this.$props);
    watch(value, (cur) => {
      if (cur) {
        showModal();
      }
    })

    const showModal = () => {
      modalConfig.modalTitle = '短信模板详情';
      modalConfig.visible = true;
    }

    const closeModal = () => {
      modalConfig.visible = false;
      this.$emit("update:value", false);
    }


    return {
      //modal相关变量
      modalConfig,
      //modal相关逻辑
      showModal,
      closeModal,
      //  业务逻辑

    }
  });
}

